import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 2a1 1 0 0 1 .993.883L23 3v1h3a2 2 0 0 1 1.994 1.85L28 6v20a2 2 0 0 1-1.85 1.994L26 28H6a2 2 0 0 1-1.995-1.85L4 26V6a2 2 0 0 1 1.85-1.995L6 4h3V3a1 1 0 0 1 1.993-.117L11 3v1h10V3a1 1 0 0 1 1-1m4 10H6v14h20zM6 6h3v1l.007.117A1 1 0 0 0 11 7V6h10v1l.007.117A1 1 0 0 0 23 7V6h3v4H6z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCalendarBlank = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCalendarBlank);
export default Memo;
